import JobOfferProComDetails from './JobOfferProComDetails'
export default JobOfferProComDetails
